import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box } from 'Components/Base';
import CreateEditForm from 'Containers/CreateEditForm';

import { getOnlineCourse } from '../../GraphQL/query/Products.query';
import { updateOnlineCourseCategoriesMutation } from '../../GraphQL/mutation/Products.mutation';
import SKUCategoriesForm from '../SKUCategoriesForm';
import { SKU_CATEGORY } from '../../Domains/constants';

class OnlineCourseCategoriesEditor extends Component {
  render() {
    const { onlineCourse = {} } = this.props;
    const { id, SKUCode } = onlineCourse;
    return (
      <Box>
        <CreateEditForm
          dataQuery={getOnlineCourse}
          editMutation={updateOnlineCourseCategoriesMutation}
          isEdit={true}
          id={SKUCode}
          idVariable={'SKUCode'}
          getQueryVariables={() => ({
            SKUCode,
          })}
          getEditVariables={(form) => ({
            id,
            data: {
              ...form,
            },
          })}
        >
          {({ data, onSubmit }) => {
            return (
              <SKUCategoriesForm
                skuCategory={SKU_CATEGORY.ONLINE_COURSE}
                initialData={data && data.sfBoProductOnlineCourse}
                onSubmit={onSubmit}
              />
            );
          }}
        </CreateEditForm>
      </Box>
    );
  }
}

export default OnlineCourseCategoriesEditor;
